module.exports = __webpack_public_path__ + "fonts/tragic-marker-regular.292ff01b.ttf";